import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import type {PickupPointType} from 'src/shared/api'

import yandexMarketSrc from '../assets/Mall.svg'
import mapSrc from '../assets/map.png'

export const slot = css`
  & + &:before {
    left: ${spacing(7)};
    right: ${spacing(2)};
  }
`
export const icon = css`
  inline-size: ${spacing(5)};
  block-size: ${spacing(5)};
  border-radius: ${spacing(1.5)};
  background: url('${mapSrc}') no-repeat center center;
  background-size: cover;
`
export const iconType: Partial<Record<PickupPointType, string>> = {
  yandex_market: css`
    background-image: url(${yandexMarketSrc});
  `,
}
export const phoneInput = css`
  ${cssTheme.default.day.line.token}: ${
    // @ts-expect-error "divider" почему-то нет в типах
    cssTheme.components.listItems.divider
  };

  ::before {
    content: none;
  }
`
